import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames';

import store from '~/store';
import mapDispatch from '~/misc/mapDispatch';
import AccountHeader from '../share/AccountHeader';
import AccountInformation from '../share/AccountInformation';
import {
  creditCardInfo,
  setDefaultCardAction,
  deleteCardAction,
  addCardAction,
  hideAsyncErrorMessage,
} from '~/modules/paymentSettingPage/actions';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import Stripe from '../../Stripe';

import sharedCss from '../share.css';
import css from './index.css';

class PaymentSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCardId: '',
    };
    this.getCardList = this.getCardList.bind(this);
    this.settingDefaultCard = this.settingDefaultCard.bind(this);
    this.deleteCreditCard = this.deleteCreditCard.bind(this);
  }

  componentWillMount() {
    this.getCardList();
  }

  render() {
    const addCardInfo = this.props.paymentSettingPage.addCardInfo;

    return (
      <div>
        <AccountHeader
          tit='Payment Setting'
          titleInfo='Your current payment method is listed below.
          Here you can edit/update your billing information and/or billing method.'
        />
        <AccountInformation msg={this.props.account.userInfo.data}/>
        <div className={cs(sharedCss.subtitle, css.removePadding)}>Credit/Debit Card Information</div>
        <div className={css.carWrap}>
          <div className={cs(css.tableWrap)}>
            <div className={css.titleWrap}>
              <div className={cs(css.flex1)}>No.</div>
              <div className={cs(css.flex2)}>Card Info</div>
              <div className={cs(css.flex1)}>Setting as default</div>
              <div className={cs(css.flex1)}>Manage</div>
            </div>
            <div className={css.bodyWrap}>
              {this.renderCardList()}
            </div>
          </div>
        </div>

        <div className={css.footer}>
          {addCardInfo.error && (<div className={cs(sharedCss.errorTips, css.tips)}>
            {hideErrorMsg('addCardInfo', addCardInfo, hideAsyncErrorMessage)}
          </div>
          )}
          <div className={cs(css.btnWrap)}>
            <Stripe btnText='Add Card' actionFn={addCardAction}/>
          </div>
        </div>
      </div>
    );
  }

  renderCardList() {
    const creditCardInfoData = this.props.paymentSettingPage.creditCardInfo;
    
    if (creditCardInfoData.loading && creditCardInfoData.isFirstLoading) {
      return (
        <div className={cs(css.itemWrap, css.addLine)}>loading...</div>
      );
    }

    // if (creditCardInfoData.error) {
    //   return (
    //     <div className={cs(css.itemWrap, css.addLine)} onClick={this.getCardList}>
    //       {creditCardInfoData.error}
    //     </div>
    //   );
    // }
    
    if (creditCardInfoData.data.cards && creditCardInfoData.data.cards.length) {
      return creditCardInfoData.data.cards.map((item, index) => (
        <div className={cs(css.itemWrap, css.addLine)}
          key={index} id={item.id}
        >
          <div className={cs(css.flex1)}>{index + 1}</div>
          <div className={cs(css.flex2, css.cardInfoWrap)}>
            <span className={css.cardFlex}>
              <em className={css.pdTop4}>**** **** ****</em>
              {item.last4}
            </span>
            <div className={cs(css.grey)}>
              <span>{item.exp_year}{'-'}{item.exp_month}</span>
              <span className={css.marginLef10}>{item.cvc_check}</span>
            </div>
                
          </div>
          <div className={cs(css.flex1)}>
            <input
              type='checkbox'
              className={css.widget_switch_checkbox}
              id={`widget_switch_checkbox${index}`}
              checked={item.default ? 'checked' : ''}
            />
            <label
              htmlFor={`widget_switch_checkbox${index}`}
              className={css.widget_switch_label}
              id={item.id}
              onClick={this.settingDefaultCard}
            >
              <span className={css.widget_switch_circle} />
            </label>
          </div>
          <div
            className={cs(css.flex1, css.strong, css.deleteBtn)}
            id={item.id}
            onClick={this.deleteCreditCard}
          >Delete</div>
          {(this.state.currentCardId === item.id)
            && this.props.paymentSettingPage.deleteCardInfo.error
            && (<div ref='toastError' className={cs(css.toastTips, css.toastErrorTips)}>
              {hideErrorMsg('deleteCardInfo', this.props.paymentSettingPage.deleteCardInfo, hideAsyncErrorMessage)}
            </div>)
          }
        </div>
      ));
    }

    return (
      <div className={cs(css.itemWrap, css.addLine)}>No Credit/Debit Card add now!</div>
    );
  }

  getCardList() {
    const obj = {
      account_id: this.props.user.id,
      token: this.props.user.token,
    };
    return store.dispatch((dispatch, getState) => creditCardInfo(dispatch, getState, obj));
  }

  deleteCreditCard(e) {
    if (this.props.paymentSettingPage.deleteCardInfo.disable) {
      return false;
    }
    const data = {
      account_id: this.props.user.id,
      card_id: e.target.id,
    };
    this.setState({
      currentCardId: e.target.id,
    });
    return store.dispatch((dispatch, getState) => deleteCardAction(dispatch, getState, data));
  }

  addCreditCard(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.paymentSettingPage.addCardInfo.disable) {
      return false;
    }
    const obj = {
      account_id: this.props.user.id,
      token: this.props.user.token,
    };
    return store.dispatch((dispatch, getState) => addCardAction(dispatch, getState, obj));
  }

  settingDefaultCard(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.target.localName !== 'label') {
      return false;
    }

    const creditCardList = this.props.paymentSettingPage.creditCardInfo.data.cards;
    let defaultVal;
    for (let i = 0; i < creditCardList.length; i++) {
      if (creditCardList[i].id === e.target.id) {
        defaultVal = creditCardList[i].default;
      }
    }

    if (this.props.paymentSettingPage.setDefaultCardInfo.disable || defaultVal) {
      return false;
    }

    const data = {
      account_id: this.props.user.id,
      card_id: e.target.id,
    };
    return store.dispatch((dispatch, getState) => setDefaultCardAction(dispatch, getState, data));
  }
}

export default connect(({user, paymentSettingPage, account}) => ({
  user,
  paymentSettingPage,
  userInfo: account.userInfo,
}), mapDispatch({}))(PaymentSetting);





// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/PaymentSetting/index.js